<header class="flex justify-between items-center mb-4">
  <h1 class="text-xl font-bold text-primary">{{ 'BACKOFFICE.NAV.RECONCILIATION' | translate }}s</h1>
  @if (isAgent) {
  <app-button routerLink="../createrequest" queryParamsHandling="merge" customClass="ml-2">
    + {{ 'REQUESTLIST.CREATE_REQUEST' | translate }}
  </app-button>
  }
</header>

@if (errorMsg !== '') {
  <app-alert [type]="'error'" [message]="errorMsg" [dismissible]="true" (dismiss)="errorMsg = ''"></app-alert>
}

<div class="content-card">
  @if (isAgent) {
  <div class="p-6">
    <div class="flex flex-wrap items-center justify-between gap-3" [formGroup]="filterForm">

    <app-input
      type="search"
      icon="search"
      formControlName="name"
      [placeholder]="'REQUESTLIST.FILTERS.SEARCH_BY_REQUEST_NAME' | translate"
      [reserveErrorSpace]="false"
      class="flex-1 min-w-[240px] max-w-xs"
    ></app-input>

    <div class="flex flex-wrap items-center gap-2">
      <!-- Statut -->
      <app-select
        variant="pill"
        [label]="'REQUESTLIST.FILTERS.STATUS' | translate"
        [items]="statusList"
        bindLabel="label"
        bindValue="code"
        [multiple]="true"
        [translateLabels]="true"
        [emptyMessage]="'REQUESTLIST.FILTERS.NO_STATUS_FOUND' | translate"
        formControlName="status"
        (selectionChange)="checkResetIfEmpty()"
      ></app-select>

      <!-- Type d'opération -->
      <app-select
        variant="pill"
        pillClass="w-48"
        [label]="'REQUESTLIST.FILTERS.OPERATION_TYPE' | translate"
        [items]="operationTypes()"
        bindLabel="name"
        bindValue="id"
        [multiple]="true"
        [emptyMessage]="'REQUESTLIST.FILTERS.NO_OPERATION_TYPE_FOUND' | translate"
        formControlName="operationTypeId"
        (selectionChange)="checkResetIfEmpty()"
      ></app-select>

      <!-- Lot -->
      <app-select
        variant="pill"
        [label]="'REQUESTLIST.FILTERS.BATCH' | translate"
        [items]="reconciliationBatches()"
        bindLabel="name"
        bindValue="id"
        [multiple]="true"
        [emptyMessage]="'REQUESTLIST.FILTERS.NO_BATCH_FOUND' | translate"
        formControlName="reconciliationBatchId"
        (selectionChange)="checkResetIfEmpty()"
      ></app-select>

      <!-- Source -->
      <app-select
        variant="pill"
        label="Source"
        [items]="filteredExternalSourcetypes()"
        bindLabel="name"
        bindValue="code"
        [multiple]="true"
        [emptyMessage]="'REQUESTLIST.FILTERS.NO_SOURCE_FOUND' | translate"
        formControlName="source1"
        (selectionChange)="checkResetIfEmpty()"
      ></app-select>

      <!-- Date -->
      <app-date-filter
        [formGroup]="filterForm"
        pillClass="w-[160px]"
        (apply)="applyFilters()"
      ></app-date-filter>

      <!-- Statut d'archivage -->
      <app-select
        variant="pill"
        [label]="'REQUESTLIST.FILTERS.ARCHIVING' | translate"
        [items]="archiveStatusList"
        bindLabel="label"
        bindValue="code"
        [multiple]="false"
        [searchable]="false"
        [translateLabels]="true"
        dropdownClass="min-w-[200px]"
        formControlName="archive"
        (selectionChange)="checkResetIfEmpty()"
      ></app-select>
    </div>
  </div>

  @if (hasActiveFilters()) {
  <div class="pt-3 mt-3 border-t border-stone-100 flex items-center justify-between">
    <div class="flex flex-wrap items-center gap-2 text-sm">
      <span class="font-semibold text-brand-muted text-xs leading-none tracking-normal whitespace-nowrap">
        {{ 'REQUESTLIST.FILTERS.ACTIVE_FILTERS' | translate }}
      </span>

      @for (chip of getActiveFilterChips(); track chip.value) {
      <span
        class="inline-flex items-center gap-1.5 px-3 py-1 bg-surface hover:bg-primary-100 text-primary text-xs font-semibold rounded-lg transition-colors">
        <span class="font-normal text-xs leading-none tracking-normal text-stone-600">{{ chip.prefix }}</span>
        <span class="font-semibold text-xs leading-none tracking-normal text-primary">{{ chip.value
          }}</span>
        <button (click)="chip.remove()"
          class="text-stone-500 hover:text-red-600 focus:outline-none shrink-0 font-bold ml-0.5 cursor-pointer">
          ✕
        </button>
      </span>
      }

      <button (click)="resetFilters()" type="button"
        class="text-xs font-semibold text-primary hover:underline ml-2 cursor-pointer">
        {{ 'REQUESTLIST.FILTERS.BUTTONS.RESET' | translate }}
      </button>
    </div>
    <app-button size="md" (btnClick)="applyFilters()">
      <app-icon-search svgClass="w-4 h-4"></app-icon-search>
      <span>{{'REQUESTLIST.FILTERS.BUTTONS.FILTER' | translate}}</span>
    </app-button>
  </div>
  }
</div>
}

  <app-data-table
  [columns]="columns"
  [data]="requestList"
  [loading]="loading"
  [emptyTitle]="'REQUESTLIST.No_REQUEST_FOUND'"
  [emptyActionLabel]="isAgent ? 'REQUESTLIST.CREATE_REQUEST' : undefined"
  [emptyActionRouterLink]="isAgent ? '../createrequest' : undefined"
  [showPagination]="true"
  [currentPage]="currentPage()"
  [totalPages]="totalPages()"
  [lastPage]="lastPage()"
  [firstPage]="firstPage()"
  (pageChange)="updateCurrentPage($event)"
  (rowClick)="showDetails($event)"
>
  <!-- Colonne Date -->
  <ng-template appTableCell="createdDate" let-request>
    <span dateTooltip [date]="request.createdDate">
      {{ request.createdDate | friendlyDate }}
    </span>
  </ng-template>

  <!-- Colonne Statut -->
  <ng-template appTableCell="status" let-request>
    <app-status-badge [status]="request.status"></app-status-badge>
  </ng-template>

  <!-- Colonne Action -->
  <ng-template appTableCell="action" let-request>
    <app-archive-button
      [archived]="request.archived"
      (toggle)="openArchiveModal(request, $event)"
    ></app-archive-button>
  </ng-template>
</app-data-table>

<!-- Archive / Unarchive Confirmation Modal -->
<app-confirm-modal
  [isOpen]="!!requestToArchive"
  [title]="requestToArchive?.archived ? 'CONFIRM_MODAL.UNARCHIVE_REQUEST_TITLE' : 'CONFIRM_MODAL.ARCHIVE_REQUEST_TITLE'"
  [message]="requestToArchive?.archived ? 'CONFIRM_MODAL.UNARCHIVE_REQUEST_MESSAGE' : 'CONFIRM_MODAL.ARCHIVE_REQUEST_MESSAGE'"
  [itemName]="requestToArchive?.name"
  [confirmLabel]="requestToArchive?.archived ? 'ACTIONS.UNARCHIVE' : 'ACTIONS.ARCHIVE'"
  variant="primary"
  [loading]="isArchivingRequest"
  (confirmed)="confirmArchiveRequest()"
  (cancelled)="closeArchiveModal()"
></app-confirm-modal>
</div>